<template>
  <svg aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#63CC98"
      d="M783.9 783.9c-101.5 101.5-266.2 101.5-367.7 0-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l.3.3c117.1 116.8 306.6 116.8 423.7 0l.3-.3c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.9-28.3 0zm-367.8-367.8c101.5-101.5 266.2-101.5 367.7 0 7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-.3-.3c-117.1-116.8-306.6-116.8-423.7 0l-.3.3c-7.8 7.8-7.8 20.5 0 28.3 7.9 7.9 20.5 7.9 28.3 0z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M896.6 331.6l73.5-73.5c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0l-73.5 73.5c-157-142.3-399.7-137.7-551.2 13.8-151.5 151.5-156.1 394.2-13.8 551.2l-73.5 73.5c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l73.5-73.5c157 142.3 399.7 137.7 551.2-13.8 151.5-151.4 156.1-394.1 13.8-551.2zm-42 523c-140.6 140.5-368.6 140.5-509.2 0s-140.6-368.5 0-509.1 368.5-140.6 509.1 0c140.6 140.5 140.6 368.5.1 509.1z"
    ></path>
    <path
      fill="#7DB9D8"
      d="M356 665l122-81.3 122 81.3 122-81.3 122 81.3 115.8-77.2c-.5-15.1-2-30.2-4.4-45.2l-111.4 74.3-122-81.3-122 81.3-122-81.3-122 81.3-111.4-74.3c-2.4 15-3.9 30.1-4.4 45.2l115.8 77.2z"
    ></path>
  </svg>
</template>
